import { render, staticRenderFns } from "./productNetworks.vue?vue&type=template&id=8edd5840&scoped=true&"
import script from "./productNetworks.vue?vue&type=script&lang=js&"
export * from "./productNetworks.vue?vue&type=script&lang=js&"
import style0 from "./productNetworks.vue?vue&type=style&index=0&id=8edd5840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edd5840",
  null
  
)

export default component.exports